import { render, staticRenderFns } from "./SummaryAccolades.vue?vue&type=template&id=35f2c112"
import script from "./SummaryAccolades.vue?vue&type=script&lang=js"
export * from "./SummaryAccolades.vue?vue&type=script&lang=js"
import style0 from "./SummaryAccolades.vue?vue&type=style&index=0&id=35f2c112&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports